import useSWR from 'swr'

import { outgoingFetcher, errorFetcher } from 'utils/fetcher'
import useAuth from './useAuth'

const useInstanceConfiguration = ({ instanceName, internalOnly = false }) => {
  const { user } = useAuth()
  let endpoint = 'instance-configurations'

  if (internalOnly) {
    endpoint = 'internal-instance-configurations'
  }

  const getInstanceName = () => {
    if (internalOnly && !user?.userId) return null
    return instanceName
  }

  const { data } = useSWR(
    getInstanceName()
      ? `${process.env.REACT_APP_BASE_URL}/${getInstanceName()}/${endpoint}`
      : null,
    internalOnly ? errorFetcher : outgoingFetcher,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: true,
      errorRetryCount: 3,
      errorRetryInterval: 1000,
    }
  )

  const instanceConfigurations = {}

  if (
    data?._embedded?.instance_configurations &&
    typeof data._embedded.instance_configurations === 'object'
  ) {
    const keys = Object.keys(data._embedded.instance_configurations)
    keys.forEach((configKey) => {
      instanceConfigurations[configKey] =
        data._embedded.instance_configurations[configKey].value
    })
  }

  return {
    instanceConfigurations: instanceConfigurations,
    isFetched:
      Boolean(data?._embedded?.instance_configurations) ||
      !instanceName ||
      data?.error,
  }
}

export default useInstanceConfiguration
